import { 
    signInWithEmailAndPassword, 
    createUserWithEmailAndPassword, 
    signOut, 
    onAuthStateChanged, 
    signInWithPopup, 
    GoogleAuthProvider 
} from 'firebase/auth';
import { auth } from './firebase-config';
import { createContext, useContext, useEffect, useState } from "react";

// Create AuthContext to share authentication state
export const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (authUser) => {
            setUser(authUser);
        });
        return () => unsubscribe();
    }, []);

    function signup(email, password) {
        return createUserWithEmailAndPassword(auth, email, password);
    }

    function signin(email, password) {
        return signInWithEmailAndPassword(auth, email, password);
    }

    function logout() { 
        return signOut(auth);
    }

    // Google Sign-In function
    function signInWithGoogle() {
        const provider = new GoogleAuthProvider();
        return signInWithPopup(auth, provider);
    }
    //show each time google signup popup for choose the account
    // async function signInWithGoogle() {

    //     await signOut(auth); // Sign out first to reset session

    //     const provider = new GoogleAuthProvider();
    //     provider.setCustomParameters({
    //         prompt: "select_account" //Forces Google to show account selection popup
    //     });
    //     return signInWithPopup(auth, provider);
    // }

    return (
        <AuthContext.Provider value={{ user, signin, signup, logout, signInWithGoogle }}>
            {children}
        </AuthContext.Provider>
    );
};
